import { c as _c } from "react/compiler-runtime";
import { BulkChangeCompanyRole } from "@components/table/members/bulk-actions/bulk-change-company-role";
import { BulkDeleteTeams } from "@components/table/teams/bulk-actions/bulk-delete-teams";
import { BulkExportTeams } from "@components/table/teams/bulk-actions/bulk-export-teams";
import { BulkRemoveMemberFromTeams } from "@components/table/teams/bulk-actions/bulk-remove-member-from-teams";
import { useTeamsAccess } from "@hooks/access-control/use-teams-access";
import { useShouldShowBulkAction } from "@hooks/table/use-should-show-bulk-action";
import { useAppParams } from "@router/router-helper";
import { useAppSelector } from "@store/store-helper";
import { fetchingTeamsFlagsSelector } from "@store/teams/teams-selector";
import { selectedEntitiesSelector } from "@store/table/table-selector";
import { useMemo } from "react";
/** List all the bulk action components for teams table */
export function useTeamsPageBulkActions(t0) {
  const $ = _c(37);
  const {
    companyId,
    teams,
    shouldExcludeRemove: t1
  } = t0;
  const shouldExcludeRemove = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = selectedEntitiesSelector("teams");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const selectedEntities = useAppSelector(t2);
  const {
    isFetchingTeamDetails
  } = useAppSelector(fetchingTeamsFlagsSelector);
  const isFetching = isFetchingTeamDetails === "pending";
  const isAnyRowSelected = selectedEntities.length !== 0;
  const {
    canDeleteTeams,
    canChangeTeamRole,
    canDeleteMembersFromTeam
  } = useTeamsAccess();
  const {
    memberId
  } = useAppParams();
  let t3;
  if ($[1] !== selectedEntities) {
    t3 = selectedEntities.some(_temp);
    $[1] = selectedEntities;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const isAnyIsManaged = t3;
  let allowedButtons;
  if ($[3] !== canChangeTeamRole || $[4] !== canDeleteMembersFromTeam || $[5] !== canDeleteTeams || $[6] !== isAnyIsManaged || $[7] !== isAnyRowSelected || $[8] !== memberId || $[9] !== shouldExcludeRemove) {
    allowedButtons = ["export"];
    if (isAnyRowSelected) {
      if (canChangeTeamRole) {
        allowedButtons.push("changeRole");
      }
      if (!shouldExcludeRemove && canDeleteTeams && !isAnyIsManaged) {
        allowedButtons.push("removeTeam");
      }
      if (memberId && canDeleteMembersFromTeam && !isAnyIsManaged) {
        allowedButtons.push("removeMemberFromTeams");
      }
    }
    $[3] = canChangeTeamRole;
    $[4] = canDeleteMembersFromTeam;
    $[5] = canDeleteTeams;
    $[6] = isAnyIsManaged;
    $[7] = isAnyRowSelected;
    $[8] = memberId;
    $[9] = shouldExcludeRemove;
    $[10] = allowedButtons;
  } else {
    allowedButtons = $[10];
  }
  const allowedButtonsBasedOnRowSelection = allowedButtons;
  let t4;
  if ($[11] !== allowedButtonsBasedOnRowSelection) {
    t4 = {
      allowedButtonsBasedOnRowSelection
    };
    $[11] = allowedButtonsBasedOnRowSelection;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const {
    shouldShowBulkButtons
  } = useShouldShowBulkAction(t4);
  let t5;
  if ($[13] !== isFetching || $[14] !== shouldShowBulkButtons || $[15] !== teams) {
    t5 = shouldShowBulkButtons("export") && (isFetching || teams.length > 0);
    $[13] = isFetching;
    $[14] = shouldShowBulkButtons;
    $[15] = teams;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const shouldShowExportButton = t5;
  let t6;
  if ($[17] !== companyId || $[18] !== shouldShowBulkButtons) {
    t6 = shouldShowBulkButtons("changeRole") ? <BulkChangeCompanyRole companyId={companyId} entityType="teams" /> : null;
    $[17] = companyId;
    $[18] = shouldShowBulkButtons;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== companyId || $[21] !== shouldShowBulkButtons) {
    t7 = shouldShowBulkButtons("removeTeam") ? <BulkDeleteTeams companyId={companyId} /> : null;
    $[20] = companyId;
    $[21] = shouldShowBulkButtons;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== companyId || $[24] !== memberId || $[25] !== shouldShowBulkButtons) {
    t8 = shouldShowBulkButtons("removeMemberFromTeams") && memberId ? <BulkRemoveMemberFromTeams companyId={companyId} memberId={memberId} /> : null;
    $[23] = companyId;
    $[24] = memberId;
    $[25] = shouldShowBulkButtons;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== isAnyRowSelected || $[28] !== selectedEntities || $[29] !== shouldShowExportButton || $[30] !== teams) {
    t9 = shouldShowExportButton ? <BulkExportTeams selectedTeams={isAnyRowSelected ? selectedEntities : teams} areEntitiesSelected={isAnyRowSelected} /> : null;
    $[27] = isAnyRowSelected;
    $[28] = selectedEntities;
    $[29] = shouldShowExportButton;
    $[30] = teams;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== t6 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t10 = {
      changeRole: t6,
      removeTeam: t7,
      removeMemberFromTeams: t8,
      export: t9
    };
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  return t10;
}
function _temp(team) {
  return team.category.isManaged;
}